<template>
    <div>
        <slot v-bind:open="open">
            <button @click="open" class="cursor-pointer rounded py-2 block text-grey-dark font-bold">
                <i class="fa fa-folder-open-o"></i> Load
            </button>
        </slot>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal = false">

                <ul class="mb-8 list-reset flex">
                    <li><a @click="type='csv'" class="block px-4 py-2 border-blue-dark cursor-pointer" :class="{'border-b-2': type==='csv'}">CSV</a></li>
                    <li><a @click="type='file'" class="block px-4 py-2 border-blue-dark cursor-pointer" :class="{'border-b-2': type==='file'}">File</a></li>
                </ul>

                <import-csv v-show="type==='csv'"></import-csv>

                <import-file v-show="type==='file'"></import-file>

            </modal>
        </portal>
    </div>
</template>

<script>
    import ImportCsv from "./ImportCsv";
    import ImportFile from "./ImportFile";

    export default {
        components: {ImportCsv, ImportFile},
        data: () => ({
            showModal: false,
            type: 'csv',
        }),

        name: "ImportData",

        methods: {
            open() {
                this.showModal = true;
            }
        }
    }
</script>

<style scoped>

</style>
